module.exports = __webpack_public_path__ + "img/Header5.265bc6e7.jpg";